import { render, staticRenderFns } from "./EstudiosTable.vue?vue&type=template&id=36e0be5f"
import script from "./EstudiosTable.vue?vue&type=script&lang=js"
export * from "./EstudiosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports